import { Controller } from "react-hook-form";
import TextField from "../../../text-field/text-field";
import { getApiConfigSafe } from "../../../../utils/api-config";

import "./element.scss";
import { IconButton, InputAdornment } from "@mui/material";
import React from "react";


interface DynamicInputProps {
  formControl: any;
  fieldArrayName: string;
  name: string;
  label?: string;
  placeholder?: string;
  type?: 'text' | 'number' | 'currency' | 'geoLocation' | 'relation';
  defaultValue?: any;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  position?: number;
  formType?: string;
  is_multiline?: boolean;
  min?: number;
  max?: number;
  min_length?: number;
  max_length?: number;
  float_step?: number | 'any';
  shouldApplyPrecission?: boolean;
  endIcon?: React.ReactNode;
  onIconClick?: () => void;
  InputProps?: any;
  onBlur?: (e: any) => void;
}

const DynamicInput = React.memo((props: DynamicInputProps) => {

  return (
    <Controller
      control={props.formControl}
      name={`${props.fieldArrayName}.${props.name}`}
      // defaultValue={props.defaultValue || ""}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          dataPosition={props.position}
          dataName={`${props.fieldArrayName}.${props.name}`}
          fullWidth
          label={props.label}
          defaultValue={
            props.type === "number" ||
              props.type === "currency" ||
              props.type === "geoLocation"
              ? typeof props.defaultValue === 'string' ? props.defaultValue.replace(/[^0-9]/g, "") : props.defaultValue
              : props.defaultValue || ""
          }
          // value={props.formType === "builder" ? props.defaultValue : ""}
          placeholder={props.placeholder}
          // onChange={(e) => {
          //   field.onChange(e);
          //   props.formControl.fieldArrayDirty[props.fieldArrayName] = true;
          // }}
          type={
            props.type === "currency" ||
              props.type === "geoLocation" ||
              props.type === "relation"
              ? "text"
              : props.type || "text"
          }
          // value={
          //   props.type === "number" && typeof field.value === 'number'
          //     ? (props?.shouldApplyPrecission === false || ['exchange_rate'].includes(props.name)) ? field.value : field.value.toFixed(2)
          //     : field.value || ""
          // }
          value={
            props.type === "number" && typeof field.value === 'number'
              ? (props?.shouldApplyPrecission === false || ['exchange_rate'].includes(props.name))
                ? field.value
                : (() => {
                  const step = props?.float_step
                  const decimalPlaces = step && step !== 'any'
                    ? (String(step).split('.')[1]?.length ?? 2)
                    : getApiConfigSafe()?.countryEnv === 'ksa' ? 4 : 2
                  return Number(field.value.toFixed(decimalPlaces)).toString()
                })()
              : field.value || ""
          }
          multiline={props.is_multiline || false}
          minRows={4}
          required={props.formType === "builder" ? false : props.required}
          // onChange={(e) => {
          //   return;
          // }}
          onChange={(e: any) => {
            if (props.onlyNumbers) {
              let numericValue = e.target.value.replace(/[^0-9]/g, "");
              const maxLen = props.max_length || props.max;
              if (maxLen) numericValue = numericValue.slice(0, maxLen);
              field.onChange(numericValue);
            } else {
              field.onChange(e);
            }
          }}
          InputProps={{
            // inputMode: 'numeric',
            // pattern: '[0-9]*',
            minLength: props.min || 1,
            // maxLength: props.max || 255,
            // step: props?.float_step || "0",
            endAdornment: props.endIcon ? (
              <InputAdornment position="end">
                <IconButton edge="end" onClick={props?.onIconClick}>
                  {props.endIcon}
                </IconButton>
              </InputAdornment>
            ) : undefined,
            ...props.InputProps,
          }}
          inputProps={{
            step: props?.float_step || 'any',
            min: props.min_length || undefined,
            maxLength: props.max_length || props.max || 255,
            inputMode: props.type === "number" ? 'numeric' : undefined,
            onWheel: (e: React.WheelEvent<HTMLInputElement>) => (e.target as HTMLInputElement).blur(),
            onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
            },
          }}
          disabled={props.disabled}
          hidden={props.hidden}
          error={Boolean(fieldState.error?.message)}
          helperText={fieldState.error?.message || ""}
          onBlur={(e: any) => {
            field.onBlur(e)
            if (props.onBlur && typeof props.onBlur === 'function') {
              props.onBlur(e)
            }
          }}
        />
      )}
    />
  );
});

export { DynamicInput };
export default DynamicInput;
